import { styled } from '@mui/material/styles'

export const RecentFilesStyles = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const RecentFilesConStyles = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.customBorderRadius.main,
  padding: '8px 9px',
  marginBottom: '8px',
  overflow: 'hidden',
}))

export const RecentFilesTopContainerStyles = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
})

export const RecentFilesHeaderStyles = styled('h3')({
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
})

export const RecentFilesSelectStyles = styled('select')(({ theme }) => ({
  border: 'none',
  backgroundColor: '#E6E6E6',
  borderRadius: theme.shape.customBorderRadius.main,
  height: '24px',
  width: '110px',
  padding: '0 6px',
  fontWeight: '500',
  fontSize: '12px',
  lineHeight: '12px',
}))

export const RecentFilesContainerStyles = styled('div')({
  marginBottom: '12px',
})

export const RecentFilesContentStyles = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const RecentFilesImageContainerStyles = styled('div')({
  width: '40px',
  height: '40px',
  borderRadius: '6px 0px 6px 6px',
})

export const RecentFilesTitleConStyles = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '12px',
})

export const RecentFilesSubTitleStyles = styled('span')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  color: theme.palette.text.primary,
}))

export const RecentFilesOtherTitleStyles = styled('span')(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '19.92px',
  letterSpacing: '0.4px',
  color: theme.palette.text.secondary,
}))

export const RecentFilesTitleStyles = styled('p')({
  fontSize: '14px',
  lineHeight: '18px',
  marginBottom: '4px',
})

export const RecentFilesDownloadStyles = styled('a')(({ theme }) => ({
  width: '24px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}))

export const RecentFilesIconStyles = styled('button')(({ theme }) => ({
  width: '24px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'transparent',
  cursor: 'pointer',
  color: theme.palette.primary.main,
}))

export const RecentFilesNoFileStyles = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100px',
})
